// src/data/colorPalettes.js
// Curated color palettes for miniature painting
// Each theme has multiple hand-picked palettes

export const COLOR_PALETTES = {
  cyberpunk: {
    name: "Cyberpunk",
    icon: "🌃",
    description: "Neon lights and dark futures",
    palettes: [
      {
        name: "Neon Nights",
        colors: ["#0A0E1A", "#1A1F2E", "#D946EF", "#06B6D4", "#FF006E", "#F0ABFC"]
      },
      {
        name: "Tokyo Rain",
        colors: ["#0D0D14", "#2D1B69", "#FF0080", "#00F5FF", "#FF1B8D", "#8EFFFF"]
      },
      {
        name: "Corporate Elite",
        colors: ["#050505", "#1E3A5F", "#00FFD1", "#FF2E63", "#06FFA5", "#FFE5EC"]
      },
      {
        name: "Hacker's Glow",
        colors: ["#0A0A0F", "#1A1A2E", "#00FF41", "#FF2C75", "#39FF14", "#76FF03"]
      },
      {
        name: "Data Ghost",
        colors: ["#0A0E1A", "#1E3A5F", "#0EA5E9", "#38BDF8", "#E0F2FE", "#FFFFFF"]
      },
      {
        name: "Street Samurai",
        colors: ["#0A0A0A", "#1A0505", "#DC2626", "#F87171", "#18181B", "#A3A3A3"]
      }
    ]
  },

  space: {
    name: "Space",
    icon: "🌌",
    description: "Deep space and nebulas",
    palettes: [
      {
        name: "Deep Void",
        colors: ["#050510", "#0D1425", "#1E3A8A", "#3B82F6", "#7C3AED", "#C4B5FD"]
      },
      {
        name: "Purple Nebula",
        colors: ["#0A0515", "#1C1035", "#6D28D9", "#A855F7", "#C084FC", "#F3E8FF"]
      },
      {
        name: "Supernova Dawn",
        colors: ["#020817", "#1E1B4B", "#DC2626", "#F59E0B", "#FBBF24", "#FEF3C7"]
      },
      {
        name: "Ice Giant",
        colors: ["#0C1222", "#1E3A8A", "#0EA5E9", "#38BDF8", "#7DD3FC", "#E0F2FE"]
      },
      {
        name: "Emerald Nebula",
        colors: ["#0A1628", "#064E3B", "#059669", "#10B981", "#6EE7B7", "#D1FAE5"]
      },
      {
        name: "Red Giant",
        colors: ["#450A0A", "#7C2D12", "#DC2626", "#F59E0B", "#FCD34D", "#FEF9C3"]
      },
      {
        name: "Binary Star",
        colors: ["#020817", "#1E3A8A", "#3B82F6", "#FBBF24", "#FDE047", "#FFFBEB"]
      }
    ]
  },

  alien: {
    name: "Alien Worlds",
    icon: "👽",
    description: "Otherworldly color schemes",
    palettes: [
      {
        name: "Xenomorph Hive",
        colors: ["#1A2E1A", "#2D5016", "#4D7C0F", "#84CC16", "#BEF264", "#F7FEE7"]
      },
      {
        name: "Crystal Entity",
        colors: ["#1E1B4B", "#4C1D95", "#C026D3", "#E879F9", "#F0ABFC", "#FAE8FF"]
      },
      {
        name: "Toxic Pools",
        colors: ["#14532D", "#365314", "#65A30D", "#84CC16", "#BEF264", "#FEFCE8"]
      },
      {
        name: "Bioluminescence",
        colors: ["#042F2E", "#064E3B", "#059669", "#34D399", "#A7F3D0", "#ECFDF5"]
      },
      {
        name: "Insectoid Chitin",
        colors: ["#1C1917", "#365314", "#4D7C0F", "#713F12", "#A8A29E", "#E7E5E4"]
      },
      {
        name: "Energy Being",
        colors: ["#1E1B4B", "#3B82F6", "#06B6D4", "#22D3EE", "#FDE047", "#FFFBEB"]
      }
    ]
  },

  mech: {
    name: "Mech/Robot",
    icon: "🤖",
    description: "Metallic with accent colors",
    palettes: [
      {
        name: "Gunmetal Grey",
        colors: ["#18181B", "#27272A", "#52525B", "#A1A1AA", "#E4E4E7", "#F4F4F5"]
      },
      {
        name: "Blue Steel",
        colors: ["#1E293B", "#334155", "#475569", "#94A3B8", "#1E40AF", "#60A5FA"]
      },
      {
        name: "Combat Red",
        colors: ["#0A0A0A", "#262626", "#525252", "#A3A3A3", "#DC2626", "#F87171"]
      },
      {
        name: "Stealth Operative",
        colors: ["#020617", "#0F172A", "#334155", "#64748B", "#10B981", "#6EE7B7"]
      },
      {
        name: "Hazard Yellow",
        colors: ["#1C1917", "#404040", "#737373", "#A3A3A3", "#EAB308", "#FDE047"]
      },
      {
        name: "Prototype White",
        colors: ["#0F172A", "#E4E4E7", "#F4F4F5", "#FAFAFA", "#3B82F6", "#60A5FA"]
      }
    ]
  },

  fantasy: {
    name: "High Fantasy",
    icon: "⚔️",
    description: "Rich medieval colors",
    palettes: [
      {
        name: "Royal Purple",
        colors: ["#1E1B4B", "#4C1D95", "#7C3AED", "#A78BFA", "#C4B5FD", "#EDE9FE"]
      },
      {
        name: "Knight's Honor",
        colors: ["#1E293B", "#475569", "#64748B", "#CBD5E1", "#B91C1C", "#FCA5A5"]
      },
      {
        name: "Elven Forest",
        colors: ["#14532D", "#166534", "#16A34A", "#4ADE80", "#BBF7D0", "#F0FDF4"]
      },
      {
        name: "Dragon Gold",
        colors: ["#78350F", "#92400E", "#D97706", "#FBBF24", "#FDE68A", "#FEF9C3"]
      },
      {
        name: "Crimson Crusader",
        colors: ["#450A0A", "#7F1D1D", "#DC2626", "#EF4444", "#FBBF24", "#FDE68A"]
      },
      {
        name: "Mystic Teal",
        colors: ["#042F2E", "#064E3B", "#0D9488", "#14B8A6", "#5EEAD4", "#CCFBF1"]
      }
    ]
  },

  dragon: {
    name: "Dragon",
    icon: "🐉",
    description: "Fire and scales",
    palettes: [
      {
        name: "Ancient Red",
        colors: ["#450A0A", "#7F1D1D", "#DC2626", "#F87171", "#FCA5A5", "#FEE2E2"]
      },
      {
        name: "Shadow Drake",
        colors: ["#0A0A0A", "#171717", "#404040", "#737373", "#A3A3A3", "#D4D4D4"]
      },
      {
        name: "Sapphire Wyrm",
        colors: ["#172554", "#1E3A8A", "#2563EB", "#60A5FA", "#BFDBFE", "#DBEAFE"]
      },
      {
        name: "Emerald Guardian",
        colors: ["#14532D", "#166534", "#16A34A", "#4ADE80", "#86EFAC", "#DCFCE7"]
      },
      {
        name: "Bronze Scales",
        colors: ["#78350F", "#92400E", "#D97706", "#FBBF24", "#FDE68A", "#FEF3C7"]
      },
      {
        name: "Frost Wyrm",
        colors: ["#0C4A6E", "#075985", "#0EA5E9", "#7DD3FC", "#E0F2FE", "#F0F9FF"]
      },
      {
        name: "Copper Dragon",
        colors: ["#431407", "#78350F", "#C2410C", "#F97316", "#FDBA74", "#FED7AA"]
      }
    ]
  },

  undead: {
    name: "Undead",
    icon: "💀",
    description: "Rot and decay",
    palettes: [
      {
        name: "Rotting Flesh",
        colors: ["#1C1917", "#44403C", "#78716C", "#A8A29E", "#65A30D", "#D6D3D1"]
      },
      {
        name: "Bleached Bone",
        colors: ["#1C1917", "#44403C", "#78716C", "#D6D3D1", "#E7E5E4", "#FAFAF9"]
      },
      {
        name: "Deathly Aura",
        colors: ["#1C1917", "#292524", "#4C1D95", "#8B5CF6", "#C4B5FD", "#F3E8FF"]
      },
      {
        name: "Plague Victims",
        colors: ["#1A2E05", "#365314", "#4D7C0F", "#84CC16", "#78716C", "#D6D3D1"]
      },
      {
        name: "Vampire Lord",
        colors: ["#0A0A0A", "#1C1917", "#450A0A", "#991B1B", "#DC2626", "#FCA5A5"]
      },
      {
        name: "Spectral Ghost",
        colors: ["#1E293B", "#334155", "#0EA5E9", "#38BDF8", "#BAE6FD", "#F0F9FF"]
      }
    ]
  },

  forest: {
    name: "Forest",
    icon: "🌲",
    description: "Natural greens and browns",
    palettes: [
      {
        name: "Deep Woods",
        colors: ["#14532D", "#166534", "#16A34A", "#4ADE80", "#86EFAC", "#DCFCE7"]
      },
      {
        name: "Autumn Leaves",
        colors: ["#431407", "#78350F", "#D97706", "#FBBF24", "#4D7C0F", "#84CC16"]
      },
      {
        name: "Mossy Bark",
        colors: ["#1C2E1E", "#365314", "#4D7C0F", "#84CC16", "#44403C", "#A8A29E"]
      },
      {
        name: "Tropical Jungle",
        colors: ["#052E16", "#14532D", "#15803D", "#22C55E", "#86EFAC", "#D1FAE5"]
      },
      {
        name: "Pine Grove",
        colors: ["#052E16", "#14532D", "#166534", "#22C55E", "#44403C", "#78716C"]
      },
      {
        name: "Spring Bloom",
        colors: ["#14532D", "#22C55E", "#86EFAC", "#F0ABFC", "#FDE047", "#FEF9C3"]
      }
    ]
  },

  grimdark: {
    name: "Grimdark",
    icon: "⚙️",
    description: "Dark and gritty",
    palettes: [
      {
        name: "Battle Worn",
        colors: ["#1C1917", "#292524", "#57534E", "#78716C", "#7C2D12", "#B91C1C"]
      },
      {
        name: "Rust & Blood",
        colors: ["#1C1917", "#292524", "#92400E", "#B45309", "#991B1B", "#DC2626"]
      },
      {
        name: "Industrial Decay",
        colors: ["#0A0A0A", "#171717", "#404040", "#737373", "#854D0E", "#A8A29E"]
      },
      {
        name: "Scorched Earth",
        colors: ["#1C1917", "#44403C", "#78350F", "#B45309", "#78716C", "#D6D3D1"]
      },
      {
        name: "Trench Warfare",
        colors: ["#1C1917", "#44403C", "#57534E", "#78716C", "#78350F", "#A8A29E"]
      },
      {
        name: "Ash & Cinder",
        colors: ["#0A0A0A", "#262626", "#525252", "#A3A3A3", "#DC2626", "#FB923C"]
      }
    ]
  },

  military: {
    name: "Military",
    icon: "🎖️",
    description: "Camo and tactical",
    palettes: [
      {
        name: "Woodland Camo",
        colors: ["#1C2E1E", "#365314", "#4D7C0F", "#78350F", "#44403C", "#78716C"]
      },
      {
        name: "Desert Storm",
        colors: ["#78350F", "#B45309", "#D97706", "#FBBF24", "#FDE68A", "#A8A29E"]
      },
      {
        name: "Urban Warfare",
        colors: ["#1C1917", "#292524", "#52525B", "#78716C", "#A8A29E", "#D6D3D1"]
      },
      {
        name: "Naval Fleet",
        colors: ["#1E293B", "#334155", "#64748B", "#94A3B8", "#1E40AF", "#3B82F6"]
      },
      {
        name: "Arctic Camo",
        colors: ["#334155", "#64748B", "#94A3B8", "#CBD5E1", "#E2E8F0", "#F8FAFC"]
      },
      {
        name: "Jungle Patrol",
        colors: ["#052E16", "#14532D", "#166534", "#22C55E", "#365314", "#78716C"]
      }
    ]
  },

  chaos: {
    name: "Chaos",
    icon: "😈",
    description: "Corrupted and warped",
    palettes: [
      {
        name: "Warp Corruption",
        colors: ["#1E1B4B", "#4C1D95", "#7C3AED", "#C084FC", "#DC2626", "#F87171"]
      },
      {
        name: "Daemonic Red",
        colors: ["#450A0A", "#7F1D1D", "#DC2626", "#F87171", "#6D28D9", "#C4B5FD"]
      },
      {
        name: "Nurgle's Rot",
        colors: ["#14532D", "#365314", "#4D7C0F", "#84CC16", "#78716C", "#A8A29E"]
      },
      {
        name: "Slaanesh Excess",
        colors: ["#4C0519", "#831843", "#DB2777", "#F472B6", "#FBCFE8", "#FCE7F3"]
      },
      {
        name: "Khorne Berserker",
        colors: ["#450A0A", "#7F1D1D", "#DC2626", "#F87171", "#78350F", "#D97706"]
      },
      {
        name: "Tzeentch Sorcerer",
        colors: ["#1E1B4B", "#4C1D95", "#8B5CF6", "#C084FC", "#DB2777", "#F9A8D4"]
      }
    ]
  },

  steampunk: {
    name: "Steampunk",
    icon: "⚗️",
    description: "Brass and leather",
    palettes: [
      {
        name: "Brass & Copper",
        colors: ["#78350F", "#92400E", "#D97706", "#FBBF24", "#FDE68A", "#FEF3C7"]
      },
      {
        name: "Victorian Leather",
        colors: ["#431407", "#713F12", "#92400E", "#1E293B", "#475569", "#94A3B8"]
      },
      {
        name: "Clockwork Gears",
        colors: ["#78350F", "#D97706", "#FBBF24", "#404040", "#737373", "#D4D4D4"]
      },
      {
        name: "Airship Captain",
        colors: ["#431407", "#78350F", "#B45309", "#1E293B", "#64748B", "#CBD5E1"]
      },
      {
        name: "Iron & Coal",
        colors: ["#0A0A0A", "#262626", "#404040", "#78350F", "#92400E", "#D97706"]
      },
      {
        name: "Gilded Age",
        colors: ["#431407", "#92400E", "#D97706", "#FBBF24", "#7C2D12", "#DC2626"]
      }
    ]
  },

  cosmic: {
    name: "Cosmic",
    icon: "✨",
    description: "Vibrant nebula colors",
    palettes: [
      {
        name: "Galaxy Burst",
        colors: ["#050510", "#1E1B4B", "#7C3AED", "#E879F9", "#F472B6", "#FDE047"]
      },
      {
        name: "Supernova",
        colors: ["#0A0A0F", "#1E3A8A", "#3B82F6", "#22D3EE", "#FBBF24", "#FEF3C7"]
      },
      {
        name: "Star Birth",
        colors: ["#020817", "#4C1D95", "#EC4899", "#F472B6", "#FB923C", "#FEF9C3"]
      },
      {
        name: "Aurora Borealis",
        colors: ["#0C1222", "#1E40AF", "#06B6D4", "#22D3EE", "#34D399", "#ECFDF5"]
      },
      {
        name: "Black Hole",
        colors: ["#000000", "#1E1B4B", "#6D28D9", "#A855F7", "#F472B6", "#FDE047"]
      },
      {
        name: "Comet Trail",
        colors: ["#0C1222", "#1E3A8A", "#0EA5E9", "#7DD3FC", "#FDE047", "#FFFBEB"]
      }
    ]
  },

  desert: {
    name: "Desert",
    icon: "🏜️",
    description: "Warm sands and stone",
    palettes: [
      {
        name: "Sahara Dunes",
        colors: ["#78350F", "#B45309", "#F59E0B", "#FBBF24", "#FDE68A", "#FEF3C7"]
      },
      {
        name: "Red Canyon",
        colors: ["#7C2D12", "#C2410C", "#EA580C", "#FB923C", "#92400E", "#F59E0B"]
      },
      {
        name: "Desert Oasis",
        colors: ["#78350F", "#D97706", "#FBBF24", "#14532D", "#16A34A", "#86EFAC"]
      },
      {
        name: "Sandstorm",
        colors: ["#78350F", "#B45309", "#F59E0B", "#44403C", "#78716C", "#D6D3D1"]
      },
      {
        name: "Sunset Sands",
        colors: ["#7C2D12", "#DC2626", "#F59E0B", "#FBBF24", "#FB923C", "#FED7AA"]
      },
      {
        name: "Ancient Ruins",
        colors: ["#78350F", "#92400E", "#44403C", "#78716C", "#A8A29E", "#E7E5E4"]
      }
    ]
  }
};

// Helper function to get a random palette from a theme
export const getRandomPaletteForTheme = (themeId) => {
  const theme = COLOR_PALETTES[themeId];
  if (!theme || !theme.palettes || theme.palettes.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * theme.palettes.length);
  return {
    ...theme.palettes[randomIndex],
    themeInfo: {
      name: theme.name,
      icon: theme.icon,
      description: theme.description
    }
  };
};

// Get all theme info for UI
export const getThemesList = () => {
  return Object.keys(COLOR_PALETTES).map(id => ({
    id,
    name: COLOR_PALETTES[id].name,
    icon: COLOR_PALETTES[id].icon,
    description: COLOR_PALETTES[id].description,
    paletteCount: COLOR_PALETTES[id].palettes.length
  }));
};